import * as React from 'react';
import { AppSession } from 'src/models/AppSession';
import { IUserFormSubmission } from 'src/models/dto/DashboardModels';

export const AppContext = React.createContext<AppSession>(AppSession.current);
export const UserFormSubmissionContext = React.createContext<IUserFormSubmission | null>(null);
